import { useEffect, useState } from "react";
import { Modal, Input, Button, message, List, Tooltip, Popconfirm } from "antd";
import {
  PlusOutlined,
  QuestionCircleOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import AddFunctionModal from "components/modal/addFunctionCall";
import FAQModal from "components/modal/faqModal";
import { bg_button, bg_shadow } from "constant/css";
import { useLoading } from "context/loadingContext";
import getFunctionCalls from "functions/ai/getFunctionCalls";
import dayjs from "dayjs";
import ImageViewer from "components/other/imageViewer";
import deleteFunctionCall from "functions/ai/deleteFunctionCall";

const FunctionCall = () => {
  const { showLoading, hideLoading } = useLoading();
  const [functionCalls, setFunctionCall] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isFAQModalOpen, setIsFAQModalOpen] = useState(false);
  const [zoomImage, setZoomImage] = useState(null);
  useEffect(() => {
    fetchFunctionCalls();
  }, []);
  const closeZoomImage = () => {
    setZoomImage(null);
  };
  const fetchFunctionCalls = async () => {
    showLoading();
    try {
      const response = await getFunctionCalls("What is the price?");
      setFunctionCall(response.data);
    } catch (error) {
      console.error("Error fetching function calls:", error);
      message.error("Failed to fetch function calls.");
    } finally {
      hideLoading();
    }
  };

  const handleEdit = (item) => {
    // Implement edit logic
    message.info(`Edit: ${item.name}`);
  };

  const handleDelete = async (id) => {
    // Implement delete logic
    try {
      showLoading();
      const response = await deleteFunctionCall(id);
      if (response) message.success("Function call deleted successfully.");
      else message.error("Failed to delete function call.");
    } catch (error) {
      console.error("Error deleting function call:", error);
      message.error("Failed to delete function call.");
    } finally {
      hideLoading();
      fetchFunctionCalls();
    }
  };

  return (
    <div className="p-6 w-full mx-auto">
      <div className="flex justify-between mb-4">
        <Button
          icon={<QuestionCircleOutlined />}
          className={`${bg_button} text-white ${bg_shadow} border-none`}
          onClick={() => setIsFAQModalOpen(true)}
        >
          FAQ
        </Button>
        <Button
          className={`${bg_button} text-white ${bg_shadow} border-none`}
          icon={<PlusOutlined />}
          onClick={() => setIsAddModalOpen(true)}
        >
          Хариулт нэмэх
        </Button>
      </div>

      <List
        header={
          <div className="text-lg font-semibold">AI Function Call жагсаалт</div>
        }
        bordered
        dataSource={functionCalls}
        className="max-h-[550px] overflow-y-auto"
        locale={{ emptyText: "Функц алга байна" }}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Tooltip title="Засах" key="edit">
                <Button
                  icon={<EditOutlined />}
                  size="small"
                  className={`${bg_button} text-white border-none ${bg_shadow}`}
                  onClick={() => handleEdit(item)}
                />
              </Tooltip>,
              <Tooltip title="Устгах" key="delete">
                <Popconfirm
                  onConfirm={() => handleDelete(item.id)}
                  title={"Та энэ функцийг устгахдаа итгэлтэй байна уу?"}
                  okText="Тийм"
                  cancelText="Үгүй"
                >
                  <Button
                    className={`border-none ${bg_shadow}`}
                    icon={<DeleteOutlined />}
                    size="small"
                    danger
                  />
                </Popconfirm>
              </Tooltip>,
            ]}
          >
            <div className="w-full flex flex-row">
              {item.image && (
                <>
                  <img
                    onClick={() =>
                      setZoomImage(
                        `https://storage.googleapis.com/smartbilling_hubilai/ai/${item.image}`
                      )
                    }
                    src={`https://storage.googleapis.com/smartbilling_hubilai/ai/${item.image}`}
                    alt="Function"
                    className="w-[80px] h-[80px] mr-2 rounded border cursor-pointer hover:opacity-80 transition"
                  />
                </>
              )}
              <div>
                <div className="font-medium text-gray-800">
                  {item.description}
                </div>
                <div className="text-sm text-gray-500 truncate">
                  {item.answer?.slice(0, 100) || "No answer"}...
                </div>
                <div className="text-xs text-gray-400 mt-1">
                  {dayjs(item.createdAt).format("YYYY-MM-DD HH:mm")}
                </div>
              </div>
            </div>
          </List.Item>
        )}
      />
      {zoomImage && (
        <ImageViewer imageUrl={zoomImage} onClose={closeZoomImage} />
      )}
      {isAddModalOpen && (
        <AddFunctionModal
          refresh={fetchFunctionCalls}
          open={isAddModalOpen}
          onClose={() => setIsAddModalOpen(false)}
        />
      )}
      {isFAQModalOpen && (
        <FAQModal
          open={isFAQModalOpen}
          onClose={() => setIsFAQModalOpen(false)}
        />
      )}
    </div>
  );
};

export default FunctionCall;
